import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetAdherenceDigitalPayment,
	GetAdherenceDigitalPaymentModel,
	GetAdherenceDigitalPaymentParams,
} from 'domain/usecases';

export class RemoteGetAdherenceDigitalPayment implements GetAdherenceDigitalPayment {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAdherenceDigitalPaymentModel>,
	) {}

	async get({signal, ...params}: GetAdherenceDigitalPaymentParams) {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
